var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh"}},[_c('p',[_vm._v("Redirecting...")])])
}]

export { render, staticRenderFns }